import { useMemo } from 'react';

import { useCurrentWorkspace } from '~/providers/CurrentWorkspaceProvider';
import { makeImporterTasksSelectorByWorkspaceId } from '~/store/tasks/selectors';
import { useImportTasks } from '~/swr-hooks/importer/useImportTasks';
import { useAirSelector } from '~/utils/ReduxUtils';

export type UseImportManagerSessionParams = {
  refetchInterval?: number;
};

/**
 * Local importer tasks plus remote import list — same inputs ImportManager uses for
 * pane visibility and auto-open. Remote succeeded history alone does not count as a session.
 */
export const useImportManagerSession = ({ refetchInterval = 0 }: UseImportManagerSessionParams = {}) => {
  const { currentWorkspace } = useCurrentWorkspace();
  const tasksSelector = useMemo(
    () => makeImporterTasksSelectorByWorkspaceId(currentWorkspace?.id),
    [currentWorkspace?.id],
  );
  const importerTasks = useAirSelector(tasksSelector);
  const importTasks = useImportTasks({ refetchInterval });

  const hasImportSession = importTasks.hasImportsInProgress || importerTasks.length > 0;

  return {
    ...importTasks,
    hasImportSession,
    importerTasks,
    tasksSelector,
  };
};
